export default "__VITE_ASSET__d6fd257d__"